module.exports = __webpack_public_path__ + "img/jobs_i6.96c496b6.png";